import { useTranslation } from "react-i18next";

export default function Reviews() {
  const { t } = useTranslation("home");
  const testimonials = t("reviews.testimonials", { returnObjects: true }) as Array<{
    name: string;
    area: string;
    text: string;
  }>;
  const starCount = Number(t("reviews.stars")) || 5;

  return (
    <section className="bg-brand-cream py-20 md:py-[120px] w-full">
      <div className="max-w-[1400px] mx-auto px-4 md:px-10">
        {/* Header */}
        <div className="text-center mb-14 md:mb-20">
          <h2 className="font-geist font-bold text-3xl md:text-[48px] text-brand-text mb-6">
            {t("reviews.h2")}
          </h2>

          <div className="inline-flex flex-col items-center gap-4 bg-white rounded-2xl border border-brand-border px-8 py-6 md:px-12 md:py-8">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#4285F4] flex items-center justify-center">
                <span className="font-geist font-bold text-lg text-white">G</span>
              </div>
              <span className="font-geist font-bold text-lg text-brand-text">Google</span>
            </div>

            <div className="flex items-center gap-2">
              <span className="font-geist font-bold text-[42px] md:text-[56px] text-brand-text leading-none">
                {starCount}.0
              </span>
              <div className="flex flex-col items-start gap-0.5">
                <div className="flex items-center gap-1">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i
                      key={s}
                      className="ri-star-fill w-5 h-5 flex items-center justify-center text-brand-yellow text-[20px]"
                    ></i>
                  ))}
                </div>
                <span className="font-geist text-sm text-brand-text/60">
                  {t("reviews.score")}
                </span>
              </div>
            </div>

            <p className="font-geist text-sm text-brand-text/50">
              {t("reviews.subtitle")}
            </p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((tmn, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl border border-brand-border p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 hover:border-brand-yellow/40"
            >
              {/* Quote icon */}
              <div className="mb-4">
                <i className="ri-double-quotes-l w-8 h-8 flex items-center justify-center text-brand-yellow text-[28px]"></i>
              </div>

              {/* Text */}
              <p className="font-geist text-base text-brand-text leading-relaxed mb-6">
                {tmn.text}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-5 border-t border-brand-border">
                <div className="w-11 h-11 rounded-full bg-brand-yellow flex items-center justify-center shrink-0">
                  <span className="font-geist font-bold text-sm text-brand-text">
                    {tmn.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-geist font-bold text-sm text-brand-text">
                    {tmn.name}
                  </p>
                  <p className="font-geist-mono text-xs text-brand-text/50">
                    {tmn.area}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}